<template>
  <ranking-entry
    :streamer="result.streamerUser"
    :currentStatus="currentStatus"
    :rank="result.rank"
    :score="result.score"
  />
</template>

<script>
import RankingEntry from '@/components/RankingEntry'

export default {
  name: 'GamerankingCell',
  components: {
    RankingEntry,
  },
  props: {
    result: {
      rank: Number,
      score: Number,
      streamerUser: {
        nickname: String,
        iconUrl: String,
        vliveId: String,
        profileId: String,
      },
      streamerInfo: Object,
    },
    overlay: Boolean,
  },
  computed: {
    currentStatus() {
      if (!this.result.streamerInfo) return null
      return this.result.streamerInfo.currentStatus
    },
  },
}
</script>
